import type { ManagerProfile } from "api/clients/users";
import type { User } from "api/resources/User";
import React from "react";
import type { AnalyticsUserTraits } from "utils/analytics";

interface IAuthContextData {
  loaded: boolean;
  user: User;
  managerProfile?: ManagerProfile;
  analyticsUser?: AnalyticsUserTraits;
  hasLocations?: boolean;

  signUpRequired: boolean;
  locationRequired: boolean;
  linkableAccountsStatus: "idle" | "loading" | "linking-required" | "success" | "error";
}

export interface IAuthContext extends IAuthContextData {
  logout: () => Promise<void>;
  refreshUser: () => Promise<{ user: User; managerProfile: ManagerProfile } | undefined> | null;
}

export const AuthContext = React.createContext<IAuthContext>({} as IAuthContext);
